import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";
import {NameserverZone} from "@/store/models/dns/nameserver_zone";

export class NameserverRecords extends Model {

  static entity = 'nameserver_records'
  static apiEntity = 'zones'

  static fields() {
    return {
      zone: this.belongsTo(NameserverZone, 'name'),
      name: this.attr(null),
      ttl: this.attr(null),
      type:this.attr(null),
      data:this.attr(null),
      zone_id:this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    }
  }

  static async fetch(name) {
    if (!name) return
    const response = await axios.get('/dns/zones/show', {
      params: {
        zone: name
      }
    })
      NameserverRecords.insertOrUpdate({data:response.data.zone.records})
  }
}

export default NameserverRecords



// WEBPACK FOOTER //
// ./src/store/models/dns/nameserver_records.js